module.exports = __webpack_public_path__ + "img/car-yellow.fef7233a.svg";